import config from './config'
import { handleResponse } from './handle-response'
import { checkToken, authHeader } from './helpers'

async function request(path, method = 'POST', body) {
    await checkToken()
    return fetch(`${config.apiUrl}/stripe/${path}`, {
        method,
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {}),
    }).then(handleResponse)
}

export const marketingEventsService = {
    claim: () => request('tracking/claim/'),
    acknowledge: (id) => request('tracking/acknowledge/', 'POST', { id }),
    recordCheckout: (sessionId) => request(
        `session/conversion/?session_id=${encodeURIComponent(sessionId)}`, 'GET'
    ),
}
